export default {
   'features': 'Características',
   'downloads': 'Descargas',
   'roadmap': 'Hoja de ruta',
   'price': 'Precio',
   'donate': 'Donar',
   'feedback': 'Comentarios',
   'panel': 'Panel de control',
};
